import React from 'react';
import './ProjectsItem.scss';
import {ReactComponent as UploadSvg} from '../../../../assets/icons/upload2.svg';
import {ReactComponent as TrashSvg} from '../../../../assets/icons/delete-24.svg';
import {ReactComponent as InfoSvg} from '../../../../assets/icons/info.svg';
import {ReactComponent as EyeSvg} from '../../../../assets/icons/eye.svg';
import {ReactComponent as RemindSvg} from '../../../../assets/icons/remind.svg';
import {ReactComponent as Edit2Svg} from '../../../../assets/icons/edit-2.svg';
import CheckboxMUI from '../../../../shared/CheckboxMUI';
import {useHistory} from 'react-router-dom';
import dayjs from 'dayjs';
import {dateFormatWithTime, mimeTypesBrowserSupport, PERMISSIONS} from '../../../../helpers/constants';
import {acceptGeneralFormats, getIconForFormat, hasPermission} from '../../../../helpers/functions';
import {useTranslation} from 'react-i18next';
import {IconButtonMUI} from '../../../../shared';
import {useDispatch, useSelector} from 'react-redux';
import {downloadHandlerFiles, isFileTooLarge, viewHandlerFiles} from "../../../../helpers/files";
import Tooltip from "@material-ui/core/Tooltip";
import {setModal, setModalData, showConfirmPopup} from "../../../../redux/actions/app/appActions";
import {POPUPS} from "../../../../redux/actions/app/appActionTypes";
import {
    changeDocStatus,
    getDrawings
} from "../../../../redux/actions/documents/documentsActions";
import {notifySuccess} from "../../../../helpers/notifySnack";

const ProjectsItem = ({
                          el,
                          disableRedirect,
                          onCheck,
                          remind,
                          checked,
                          redirectUrl,
                          projectId,
                          removeHandler,
                          requestApprovalHandler,
                          hasCheck = true,
                          eye = true,
                          permissionTrash = false,
                          permissionDownload = false,
                          remindPermission = false,
                          remindProject = false,
                          requestApproveHandler,
                          isEstimate = false,
                          permissionChangeStatus = false,
                          permissionChangeStatusDrawing = false,
                      }) => {

    const dispatch = useDispatch();
    const history = useHistory();
    const projectList = useSelector(({projects}) => projects.projects);
    const {profileMe} = useSelector((state) => state.profile);
    const isSpectatorOrClient = profileMe?.role === 'user' || profileMe?.role === 'spectator';

    const {t} = useTranslation();

    const handleItemClick = () => {
        if (!disableRedirect) {
            history.push(`${redirectUrl.replace(':id', projectId).replace(':documentId', el.id)}`);
        }
    };

    const getFormat = el?.mime && acceptGeneralFormats[el.mime] ? acceptGeneralFormats[el.mime] : '';
    const icon = getIconForFormat(getFormat[0] ?? '');

    const findNameProjectById = () => {
        const item = projectList?.find((project) => project?.id === el?.projectId);
        return item?.address ?? '';
    };

    const isSupporView = mimeTypesBrowserSupport?.includes(el?.mime);

    const changeStatus = () => {
        dispatch(setModal(POPUPS.STATUS_DOC));

        dispatch(setModalData({
            id: el.id,
            projectId: el.projectId,
            isSinglePage: false,
            paymentStatus: el.paymentStatus,
        }))
    }

    const changeStatusDrawing = async () => {
        try {
            const res = await dispatch(changeDocStatus(el.projectId,el.id, null, 'ordered'));

            if (res.payload && res.payload.status === 202) {
                await dispatch(getDrawings(projectId, 'drawing'));
                notifySuccess(t('all.successfully'));
            }
        } catch (err) {
            console.log(err);
        }
    }


    const changeStatusDrawingRedux = () => {
        dispatch(
            showConfirmPopup({
                visible: true,
                title: t('all.drawingsPopupTitle'),
                text: t('all.drawingsPopupText'),
                confirmCallback: () => changeStatusDrawing()
            })
        );
    };

    return (
        <div className={`projects__item ${el.status}`}>
            {hasCheck && (
                <div className='projects__item-check'>
                    <CheckboxMUI onChange={onCheck} checked={checked}/>
                </div>
            )}
            <div className='projects__item-inner' onClick={handleItemClick}>
                <div className='projects__item-icon'>
                    <img src={icon} alt='icon'/>
                    {el.file?.file_size && isFileTooLarge(el.file.file_size) &&
                        <Tooltip title={t('all.largeFile')} arrow>
                            <div className={'projects__item-attention'}>
                                <InfoSvg/>
                            </div>
                        </Tooltip>

                    }

                </div>
                <div className='projects__item-data'>
                    <h3>{el.name}</h3>
                    {remind && projectList?.length ? <p>{findNameProjectById()}</p> : null}
                    <p>{dayjs(el.created_at).format(dateFormatWithTime)}</p>
                    {!isEstimate && (
                        <div className={`projects__item-status ${el.status}`}>
                            <InfoSvg/>
                            {el.status === 'confirm' && t('ProjectsItem.status_confirm')}
                            {el.status === 'new' && t('ProjectsItem.status_new')}
                            {el.status === 'requested' && t('ProjectsItem.status_requested')}
                            {(el.status === 'reject' || el.status === 'rejected') && t('ProjectsItem.status_reject')}
                            {el.status === 'approved' && t('SingleDocument.approved')}
                        </div>
                    )}
                    {el?.paymentStatus === 'partially_paid' || el?.paymentStatus === 'paid' ?
                        <div className={`projects__item-status ${el.paymentStatus}`}>
                            <InfoSvg/>
                            {el.paymentStatus === 'partially_paid' && t('Сплачено частково')}
                            {el.paymentStatus === 'paid' && t('Сплачено')}
                        </div> : null
                    }
                    {el?.orderStatus === 'ordered' && !isSpectatorOrClient ?
                        <div className={`projects__item-status ${el?.orderStatus}`}>
                            <InfoSvg/>
                            {el?.orderStatus === 'ordered' && t('all.ordered')}
                        </div> : null}
                </div>
            </div>
            <div className={`projects__item-icons`}>
                {!isEstimate && remind && remindPermission && el.status === 'requested' && (
                    <div onClick={() => requestApprovalHandler(el)}>
                        <IconButtonMUI className={'remindStyle'} color={'inherit'} title={t('ProjectsItem.remind')}>
                            <RemindSvg/>
                        </IconButtonMUI>
                    </div>
                )}
                {eye && permissionDownload && isSupporView && (
                    <div
                        onClick={() => {
                            viewHandlerFiles({
                                file: el?.file,
                                name: el?.fileName,
                                docId: el?.id,
                                projectId: el.projectId,
                            }, dispatch);
                        }}
                    >
                        <IconButtonMUI color={'inherit'} title={t('ProjectsEstimate.view')}>
                            <EyeSvg/>
                        </IconButtonMUI>
                    </div>
                )}
                {permissionDownload && (
                    <div
                        onClick={() => {
                            downloadHandlerFiles({
                                file: el?.file,
                                name: el?.fileName,
                                docId: el?.id,
                                projectId: el.projectId,

                            }, dispatch);
                        }}
                    >
                        <IconButtonMUI color={'inherit'} title={t('ProjectsDocuments.download')}>
                            <UploadSvg/>
                        </IconButtonMUI>
                    </div>
                )}
                {!isEstimate && remindProject && remindPermission && el.status === 'requested' && (
                    <div
                        onClick={() => {
                            requestApproveHandler(el.id);
                        }}
                    >
                        <IconButtonMUI className={'remindStyle'} color={'inherit'} title={t('all.remember')}>
                            <RemindSvg/>
                        </IconButtonMUI>
                    </div>
                )}

                {permissionTrash ? (
                    <div onClick={() => removeHandler(el.id)}>
                        <IconButtonMUI color={'inherit'} title={t('ProjectsDocuments.delete')}>
                            <TrashSvg/>
                        </IconButtonMUI>
                    </div>
                ) : null}

                {!isEstimate && permissionChangeStatus && el?.status === 'approved' ? <div
                    onClick={() => {
                        changeStatus();
                    }}
                >
                    <IconButtonMUI className={'remindStyle'} color={'inherit'} title={t('all.status')}>
                        <Edit2Svg/>
                    </IconButtonMUI>
                </div> : null}
                {permissionChangeStatusDrawing && el?.status === 'approved' && el.type === 'drawing' && !el.orderStatus ? <div
                    onClick={() => {
                        changeStatusDrawingRedux();
                    }}
                >
                    <IconButtonMUI className={'remindStyle'} color={'inherit'} title={t('all.drawingsPopupTitle')}>
                        <Edit2Svg/>
                    </IconButtonMUI>
                </div> : null}
            </div>
        </div>
    );
};

export default ProjectsItem;
